// extracted by mini-css-extract-plugin
export default {"socialLink":"style--socialLink--fbeced","socialDomain":"style--socialDomain--e7412a","facebookIcon":"style--facebookIcon--717df6","twitterIcon":"style--twitterIcon--a2c07c"};